import agent_attorney_no_data from "./agent_attorney_no_data";
import agent_attorney_individs_no_data from "./agent_attorney_individs_no_data";
import employer_no_data from "./employer_no_data";
import employer_pocs_no_data from "./employer_pocs_no_data";
import foreign_labor_no_data from "./foreign_labor_no_data";
import crop_no_data from "./crop_no_data";
import worker_housing_no_data from "./worker_housing_no_data";
import agriculture_no_data from "./agriculture_no_data";
import material_terms_no_data from "./material_terms_no_data";
import foreign_worker_no_data from "./foreign_worker_no_data";
import foreign_worker_group_no_data from "./foreign_worker_group_no_data";


const ProfileTableNoDataResolver = (tableName) => {
  const tableNoDataList = {
    "agent-attorney": agent_attorney_no_data,
    "agent-attorney-individs": agent_attorney_individs_no_data,
    employer: employer_no_data,
    "employer-pocs": employer_pocs_no_data,
    "foreign-labor": foreign_labor_no_data,
    crop: crop_no_data,
    "worker-housing": worker_housing_no_data,
    agriculture: agriculture_no_data,
    "material-terms": material_terms_no_data,
    "foreign-worker": foreign_worker_no_data,
    "foreign-worker-group": foreign_worker_group_no_data,
  };
  return tableNoDataList[tableName] || agent_attorney_no_data;
};

export default ProfileTableNoDataResolver;
